// extracted by mini-css-extract-plugin
export default {"spinnerTop":"SpinnerStyle_spinnerTop__GLv5h"};